import { useSelector, useDispatch } from 'react-redux';
import { get, set } from 'global/lib/lodash';

export const useShowChanges = (props) => {
  const view = useSelector((s) => s.view);
  const dispatch = useDispatch();

  const showChangesOn = get(view, 'showChanges.on', false);
  const showChangesId = get(view, 'showChanges.id', false);

  const toggleShowChanges = (id = false, change = true) => {
    const _view = { ...view };

    // if an id is passed or the user doesn't want the toggle to change
    set(_view, 'showChanges.on', !!id ? true : change ? !showChangesOn : showChangesOn);
    set(_view, 'showChanges.id', id);

    dispatch({ type: 'SET_VIEW', view: _view });
  };

  return {
    showChangesOn,
    showChangesId,
    toggleShowChanges,
  };
};
